import img1 from "../assets/p1.jpg";
import img2 from "../assets/p2.jpg";
import img3 from "../assets/p3.jpg";
import img5 from "../assets/p5.jpg";
import img8 from "../assets/p8.jpg";
import img7 from "../assets/p7.jpg";
import img9 from "../assets/p9.jpg";
import img10 from "../assets/p10.jpg";
import img12 from "../assets/p12.jpg";
/* import img11 from "../assets/p11.jpg"; */
/* import img4 from "../assets/p4.jpg";
import img6 from "../assets/p6.jpg"; */

export const PROJECTS = [
  {
    id: 8,
    title: "MeLi",
    tecnology: "React",
    img: img10,
  },
  {
    id: 7,
    title: "Donuts",
    tecnology: "Vue",
    img: img9,
  },
  {
    id: 9,
    title: "SpaceX",
    tecnology: "React",
    img: img12,
  },
  {
    id: 3,
    title: "Blockbuster Virtual",
    tecnology: "React",
    img: img3,
  },
  {
    id: 2,
    title: "Cirse",
    tecnology: "JavaScript",
    img: img2,
  },
  {
    id: 4,
    title: "Queen Be",
    tecnology: "Next JS",
    img: img8,
  },

  {
    id: 1,
    title: "Natali Ruiz de Galarreta",
    tecnology: "React",
    img: img1,
  },
  {
    id: 6,
    title: "DAxes",
    tecnology: "Next JS",
    img: img7,
  },
  {
    id: 5,
    title: "Mecatrónica",
    tecnology: "Wordpress",
    img: img5,
  },
];
